import { useIntl } from "react-intl";
import { eventParticipant, TableParticipant, subEventObject, eventObject, formInputInfo } from "../types/types";

export const arrayToObject = (array: {[key: string]: any}[], key: string) =>
   array.reduce((obj, item) => {
     obj[item[key]] = item
     return obj
   }, {})


   export const arrayToObjectVariation = (array: {[key: string]: any}[], key: string, value: string) =>
   array.reduce((obj, item) => {
     obj[item[key]] = item[value]
     return obj
   }, {})

   export const concatNarrays = (arr: string[][]) => {
    const newArr = arr.reduce((prev, next) =>  {
       return prev.concat(next);
    });
    return newArr;
}


export const searchArrayByValue = (array: any[], searchWord: string, filterKeys: string[]) => {
   const result = array.filter(
      a => filterKeys.length === 0 ? includesSearchWord(a, searchWord) : filterByKey(filterKeys, searchWord, a)
   )
   return result
}


const filterByKey = (filterKey: string[], searchWord: string,  obj: {[key: string]: string | string[] | number}) => {
   for(const key of Object.keys(obj)){
      if(filterKey.includes(key)){
         if(obj[key] && obj[key].toString().toLowerCase().includes(searchWord.toLowerCase())){
            return true
         }
      }
   }
}


const includesSearchWord = (obj: {[key: string]: string | string[] | number}, searchWord: string) => {
   for(const value of Object.values(obj)){
      if(value && value.toString().toLowerCase().includes(searchWord.toLowerCase())){
         return true
      }
   }
}

export const getArrays = (arr: string[], baskets: any) => {
   const arrayOfArrays: string[][] = []
   for (const basket of arr) {
     if ((Number(basket)) !== arr.length) {
       arrayOfArrays.push(baskets[basket].questionIds)
     }
   }
   return arrayOfArrays
 }


export const  useFormatMessage = (messageId: string) => {
   return useIntl().formatMessage({ id: messageId })
}


export function formatLink(link: string){
   if (link.substr(0,4) === 'http'){
     return link
   } else {
     return `http://${link}`
   }
 }


 export const getPageList = (page: number, limit: number, list: any[]) => {
   const offset = (page -1) * limit
   return list.slice(offset, offset + limit)
 }

 
export const toggleKey = (key: string, keys: string[]) => {
   return keys.includes(key) 
   ? keys.filter(f => f !== key)
   : keys.concat(key)
}


export const sortByKey = (key: string, ascending: boolean, list: any[]) => {
   return ascending ? 
   (
   [...list].sort((a, b) => 
   (!a[key] || !b[key]) ? 0 :
   Number.isInteger(a[key]) && Number.isInteger(b[key]) 
   ? Number(b[key]) - Number(a[key]) 
   : b[key].toString().localeCompare(a[key].toString()))
   )
     :
   (
   [...list].sort((a, b) => 
   (!a[key] || !b[key]) ? 0 :
   Number.isInteger(a[key]) && Number.isInteger(b[key]) 
   ? Number(a[key]) - Number(b[key]) 
   : a[key].toString().localeCompare(b[key].toString()))
   )
} 

export function convertParticipantToListFormat(original: eventParticipant): TableParticipant {
   const converted = {
       uuid: original.partypantsUuid,
       eventId: original.partypantsSubEventId,
       role: original.partypantsEventRole,
       qrCode: original.partypantsQrCode,
       registertime: original.partypantsRegisterTime,
       registrationState: original.partypantsRegisterState,
       invoiceState: original.partypantsInvoiceState,
       comment: original.partypantsRegistrarComment,
       customState: original.partypantsCustomState
}
   const person =  original.partypantsAnswer 
   ? original.partypantsAnswer.reduce((acc, curr) => {
       return { 
          ...acc, 
          [curr.id]: curr.answer
         }
      }, {}) 
   : {}

   const common =  original.partypantsAnswerCommon 
   ? original.partypantsAnswerCommon.reduce((acc, curr) => {
       return { 
          ...acc, 
          [curr.id]: curr.answer
           }
         }, {})
    : {}

  return {...converted, ...person, ...common}
}

export function getEventName (searchId: string, subEvents: subEventObject[], eventName: string) {
   return subEvents.length ?  subEvents.find(s => s.subEventId === searchId).subEventName : eventName
}

export function getParticipantTableStartingHeaders(eventParticipants: eventParticipant[], table: TableParticipant[]): string[]{
   const uniqueDbAnswerKeys = Array.from(new Set(eventParticipants.map(ep => ep.partypantsAnswer
      .filter(answer => answer.dbKeys)
      .map(answer => answer.id)
      .concat(ep.partypantsAnswerCommon
         .filter(answer => answer.dbKeys)
         .map(answer => answer.id)))
         .flat()))

   const firstRow = Object.keys(table[0])
   if(uniqueDbAnswerKeys.length === 0) {
      return table.length > 0 
      ? firstRow.length > 5 
      ? firstRow.slice(0, 5) 
      : firstRow 
      : []
   }
   if(uniqueDbAnswerKeys.length >= 5) {
      return uniqueDbAnswerKeys.slice(0, 5) 
   }
   return uniqueDbAnswerKeys.concat(firstRow).slice(0, 5)
}

export function convertParticipantToPartypants(updated: TableParticipant, participant: eventParticipant): eventParticipant {
   const final = {
       partypantsUuid: updated.uuid,
       partypantsSubEventId: updated.eventId,
       partypantsQrCode: updated.qrCode,
       partypantsRegisterState: updated.registrationState,
       partypantsRegisterTime: updated.registertime,
       partypantsEventRole: updated.role,
       cancelToken: participant.cancelToken,
       modifyToken: participant.modifyToken,
       modifyTokenExpiresTime: participant.modifyTokenExpiresTime,
       partypantsOverview: participant.partypantsOverview,
       partypantsInvoiceState: updated.invoiceState,
       partypantsCustomState: updated.customState,
       partypantsRegistrarComment: updated.comment
    }

    const partypantsAnswer = participant.partypantsAnswer.map(a => {
       return {
          ...a,
          answer: updated[a.id]
       }
    })
    const partypantsAnswerCommon = participant.partypantsAnswerCommon.map(a => {
      return {
         ...a,
         answer: updated[a.id]
      }
   })
   return { ...final, partypantsAnswer, partypantsAnswerCommon }
}


export function getUniqueKeysForTable(arr: {[key: string]: any}[]){
   const uniqueKeys = []
   for(const obj of arr){
      for(const key of Object.keys(obj)){
         if(!uniqueKeys.includes(key) && typeof obj[key] !== 'object'){
            uniqueKeys.push(key)
         }
      }
   }
   return uniqueKeys
}


export function move(input: any[], from: number, to: number) {
   let numberOfDeletedElm = 1;
   const copy = [...input]
   const elm = copy.splice(from, numberOfDeletedElm)[0];
 
   numberOfDeletedElm = 0;
   copy.splice(to, numberOfDeletedElm, elm);
   return [...copy]
 }


 export const insert = (arr: any[], index: number, ...newItems: any) => [
   ...arr.slice(0, index),
   ...newItems,
   ...arr.slice(index)
 ]

 export const mapFromKeysEventObject = (array: eventObject[], keys: string[], custom: string[]) => array.map(o => keys.reduce((acc, curr) => {
   const customObj = custom.map(k => k).reduce((a, k) => Object.assign(a, { [k]: customKeySubEventStats(o, k) }), {}); 
   o[curr] ? acc[curr] = o[curr] : acc[curr] = customObj[curr];
   return acc;
 }, {}));


 export const customKeySubEventStats = (event: eventObject, key: string) => event.subEvents.map(subEvent => subEvent.subEventStats).reduce((prev, curr) => { 
 return curr[key] ? prev+curr[key] : prev
}, 0)


export const mapFromKeys = (array: any[], keys: string[]) => array.map(o => keys.reduce((acc, curr) => {
   acc[curr] = o[curr]
   return acc;
 }, {}));
 
 export function returnRequiredRule(type: string, register: any) {
   if (type === 'email'){
     return register({
       required: `Form.required_any`,
       pattern: {
         value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, //eslint-disable-line
         message: `Form.required_email`
       }
     })
   } else if (type === 'phone') {
     return register({
       required: `Form.required_any`,
       pattern: {
         value: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im, //eslint-disable-line
         message: `Form.required_phone`
       }
     }) 
   }
   return register({ required: `Form.required_any`})
 }
 

 export function getEmptyFormInputObject (): formInputInfo {
    return {
      id: '', 
      question: '', 
      type: '', 
      show: false, 
      group: 1, 
      page: 1,
      hide: {
        key: '',
        value: '',
        type: ''
      },
      product: {
         multiplier: '',
         tax: ''
      },
      dbKeys: {
               key: '',
               leadKey: false,
               dbKey: false
         },
      mailKeys: {
         key: ''
      }
   }
 }